import { useEffect, useState } from "react";
import "./OnboardingPointer.scss";

function OnboardingPointer({ targetSelector, message, show }) {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    if (!show) {
      setPosition(null);
      return;
    }

    const updatePosition = () => {
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        // The arrow tip should point to the center of the button
        // Since we use translate(-50%, 0), left should be at button center
        const newPosition = {
          top: rect.bottom + 5,
          left: rect.left + rect.width / 2,
        };
        setPosition(newPosition);
      }
    };

    // Update position initially and on resize
    updatePosition();
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("resize", updatePosition);
    };
  }, [targetSelector, show]);

  if (!show || !position) {
    return null;
  }

  return (
    <div
      className="onboarding-pointer"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
    >
      <div className="pointer-arrow"></div>
      <div className="pointer-message">{message}</div>
    </div>
  );
}

export default OnboardingPointer;
